import { Brand } from "../types/domains";
import { combinedConfig } from "./combinedConfig";

export const brandsArray: Brand[] = [
  {
    name: "Lacoste",
    domains: [
      {
        name: "lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "shop-fr-staging.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "us.lacoste.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "gb.lacoste.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "br.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "de.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "at.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "be.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "ch.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "dk.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "es.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "ie.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "it.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "nl.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "pt.lacoste.com",
        unitSystem: "metric",
      },
      {
        name: "se.lacoste.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.lacoste.config,
  },
  {
    name: "KENZO",
    domains: [
      {
        name: "kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "www.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "stg.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "sb03.kenzo.com",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
    ],
    config: combinedConfig.kenzo.config,
  },
  {
    name: "Sporty & Rich",
    domains: [
      {
        name: "sportyandrich.com",
        unitSystem: "metric",
      },
      {
        name: "sporty-rich.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sportyAndRich.config,
  },
  {
    name: "Place des Tendances",
    domains: [
      {
        name: "placedestendances.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.placeDesTondances.config,
  },
  {
    name: "Le Slip Français",
    domains: [
      {
        name: "www.leslipfrancais.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.leSlipFrancais.config,
  },
  {
    name: "IZAC",
    domains: [
      {
        name: "izac.fr",
        unitSystem: "metric",
      },
      {
        name: "izac-paris.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.izac.config,
  },
  {
    name: "JOTT",
    domains: [
      {
        name: "jott.com",
        unitSystem: "metric",
      },
      {
        name: "justoverthetop-testing.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.jott.config,
  },
  {
    name: "From Future",
    domains: [
      {
        name: "www.fromfuture.com",
        unitSystem: "metric",
      },
      {
        name: "fromfuture-int.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.fromFuture.config,
  },
  {
    name: "Circle SportsWear",
    domains: [
      {
        name: "circlesportswear.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.circleSportswear.config,
  },
  {
    name: "Rodier",
    domains: [
      {
        name: "www.rodier.fr",
        unitSystem: "metric",
      },
      {
        name: "preprod02-fo-rodier.wshop.cloud",
        unitSystem: "metric",
      },
      {
        name: "en.rodier.fr",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "preprod-fo.rodier-en.wshop.cloud",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "www.rodier.be",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.at",
        unitSystem: "metric",
      },
      {
        name: "www.de-rodier.com",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.nl",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.pt",
        unitSystem: "metric",
      },
      {
        name: "www.rodier.es",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.rodier.config,
  },
  {
    name: "La Canadienne",
    domains: [
      {
        name: "la-canadienne.com",
        unitSystem: "metric",
      },
      {
        name: "la-canadienne-boutique.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "www.la-canadienne.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.laCanadienne.config,
  },
  {
    name: "Gerard Darel",
    domains: [
      {
        name: "gerarddarel.com",
        unitSystem: "metric",
      },
      {
        name: "gerard-darel-development.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "gerard-darel.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.gerardDarel.config,
  },
  {
    name: "Ron Dorff",
    domains: [
      {
        name: "rondorff.com",
        unitSystem: "metric",
      },
      {
        name: "uk.rondorff.com",
        unitSystem: "metric",
      },
      {
        name: "us.rondorff.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ronDorff.config,
  },
  {
    name: "The Kooples",
    domains: [
      {
        name: "thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "dev.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "stg.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "staging.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "www.thekooples.com",
        unitSystem: "metric",
      },
      {
        name: "getkleep-marcy-paris.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.theKooples.config,
  },
  {
    name: "Chlore",
    domains: [
      {
        name: "www.chlore-swimwear.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.chlore.config,
  },
  {
    name: "Molli",
    domains: [
      {
        name: "www.molli.com",
        unitSystem: "metric",
      },
      {
        name: "molli.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.molli.config,
  },
  {
    name: "Place du Jour",
    domains: [
      {
        name: "placedujour.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.placeDuJour.config,
  },
  {
    name: "Gualap",
    domains: [
      {
        name: "gualap.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.gualap.config,
  },
  {
    name: "Vogstore",
    domains: [
      {
        name: "vogstoree.com",
        unitSystem: "metric",
      },
      {
        name: "vog-store.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.vogstore.config,
  },
  {
    name: "SRP",
    domains: [
      {
        name: "showroomprive.com",
        unitSystem: "metric",
      },
      {
        name: "fr-v4.terone.showroomprive.net",
        unitSystem: "metric",
      },
      {
        name: "saldiprivati.com",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.es",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.pt",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.be",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.nl",
        unitSystem: "metric",
      },
      {
        name: "showroomprive.ma",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.srp.config,
  },
  {
    name: "Hartford",
    domains: [
      {
        name: "hartford.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.hartford.config,
  },
  {
    name: "La Petite Etoile",
    domains: [
      {
        name: "www.lapetiteetoile.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.laPetiteEtoile.config,
  },
  {
    name: "Mister K",
    domains: [
      {
        name: "misterk.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.misterK.config,
  },
  {
    name: "Petrone",
    domains: [
      {
        name: "petroneparis.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.petrone.config,
  },
  {
    name: "Zadig & Voltaire",
    domains: [
      {
        name: "zadig-et-voltaire.com",
        unitSystem: "metric",
      },
      {
        name: "www.preprod.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.jupiter.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.venus.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.saturne.eu.z-v.cloud",
        unitSystem: "metric",
      },
      {
        name: "www.neptune.eu.z-v.cloud",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.zadigVoltaire.config,
  },
  {
    name: "Bensimon",
    domains: [
      {
        name: "bensimon.com",
        unitSystem: "metric",
      },
      {
        name: "preprod-fo.bensimon.wshop.cloud",
        unitSystem: "metric",
      },
      {
        name: "en.bensimon.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bensimon.config,
  },
  {
    name: "Stella & Suzie",
    domains: [
      {
        name: "stellaetsuzie.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.stellaSuzie.config,
  },
  {
    name: "Antonelle",
    domains: [
      {
        name: "www.antonelle.fr",
        unitSystem: "metric",
      },
      {
        name: "antonellefr.preprod123.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.antonelle.config,
  },
  {
    name: "Une Jour Ailleurs",
    domains: [
      {
        name: "unjourailleurs.com",
        unitSystem: "metric",
      },
      {
        name: "unjourailleurscom.preprod123.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.uneJourAilleurs.config,
  },
  {
    name: "Kookai",
    domains: [
      {
        name: "kookai.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.kookai.config,
  },
  {
    name: "Asphalte",
    domains: [
      {
        name: "asphalte.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.asphalte.config,
  },
  {
    name: "Soeur",
    domains: [
      {
        name: "www.soeur.fr",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "us.soeur.fr",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "www.soeur.uk",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
    ],
    config: combinedConfig.soeur.config,
  },
  {
    name: "Et Paris",
    domains: [
      {
        name: "etparis.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.etParis.config,
  },
  {
    name: "Faguo",
    domains: [
      {
        name: "www.faguo-store.com",
        unitSystem: "metric",
      },
      {
        name: "faguo-store.com",
        unitSystem: "metric",
      },
      {
        name: "faguo-dev01.sidemo.fr",
        unitSystem: "metric",
      },
      {
        name: "preprod01.faguo-store.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.faguo.config,
  },
  {
    name: "Project X Paris",
    domains: [
      {
        name: "www.projectxparis.com",
        unitSystem: "metric",
      },
      {
        name: "project-x-paris-shop.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.projectXParis.config,
  },
  {
    name: "Hast",
    domains: [
      {
        name: "www.hastparis.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.hast.config,
  },
  {
    name: "SAAJ",
    domains: [
      {
        name: "saajparis.fr",
        unitSystem: "metric",
      },
      {
        name: "saajparis.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.saaj.config,
  },
  {
    name: "Bonne Gueule",
    domains: [
      {
        name: "bonnegueule.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bonneGueule.config,
  },
  {
    name: "Devred",
    domains: [
      {
        name: "devred.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.devred.config,
  },
  {
    name: "Theodore",
    domains: [
      {
        name: "theodore.ae",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.theodore.config,
  },
  {
    name: "LTDC",
    domains: [
      {
        name: "letempsdescerises.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ltdc.config,
  },
  {
    name: "Nina Ricci",
    domains: [
      {
        name: "www.ninaricci.com",
        unitSystem: "metric",
      },
      {
        name: "ninaricci-development-eur.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "ninaricci-global.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ninaRicci.config,
  },
  {
    name: "Maison Kitsuné",
    domains: [
      {
        name: "maisonkitsune.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.maisonKitsune.config,
  },
  {
    name: "Victoria Beckham",
    domains: [
      {
        name: "victoriabeckham.com",
        unitSystem: "metric",
      },
      {
        name: "www.victoriabeckham.com",
        unitSystem: "imperial",
        defaultBraSize: "UK",
      },
      {
        name: "victoria-beckham-uk.myshopify.com",
        unitSystem: "imperial",
      },
      {
        name: "international.victoriabeckham.com",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "victoria-beckham-international.myshopify.com",
        unitSystem: "metric",
      },
      {
        name: "us.victoriabeckham.com",
        unitSystem: "imperial",
        defaultBraSize: "US",
      },
      {
        name: "victoria-beckham-us.myshopify.com",
        unitSystem: "imperial",
      },
    ],
    config: combinedConfig.victoriaBeckham.config,
  },
  {
    name: "Rabanne",
    domains: [
      {
        name: "fashion.rabanne.com",
        unitSystem: "metric",
      },
      {
        name: "rabanne.com",
        unitSystem: "metric",
      },
      {
        name: "stag-fashion.rabanne.com",
        unitSystem: "metric",
      },
      {
        name: "stag-fashion.rabanne.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.rabanne.config,
  },
  {
    name: "Weill",
    domains: [
      {
        name: "www.weill.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.weill.config,
  },
  {
    name: "Sud Express",
    domains: [
      {
        name: "www.sudexpress.fr",
        unitSystem: "metric",
      },
      {
        name: "sudexpress.com",
        unitSystem: "metric",
      },
      {
        name: "www.sudexpress.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sudExpress.config,
  },
  {
    name: "Loom",
    domains: [
      {
        name: "www.loom.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.loom.config,
  },
  {
    name: "Alme",
    domains: [
      {
        name: "www.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "de.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "it.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "gb.almeparis.com",
        unitSystem: "imperial",
      },
      {
        name: "es.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "pt.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "nl.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "se.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "ch.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "fi.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "dk.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "pl.almeparis.com",
        unitSystem: "metric",
      },
      {
        name: "at.almeparis.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.alme.config,
  },
  {
    name: "Sport 2000",
    domains: [
      {
        name: "www.sport2000.fr",
        unitSystem: "metric",
      },
      {
        name: "sport2000.fr",
        unitSystem: "metric",
      },
      {
        name: "ecom.sport2000.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.sport2000.config,
  },
  {
    name: "Loro Piana",
    domains: [
      {
        name: "fr.loropiana.com",
        unitSystem: "metric",
      },
      {
        name: "demo.kleep.ai",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.loropiana.config,
  },
  {
    name: "Givenchy",
    domains: [
      {
        name: "www.givenchy.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.givenchy.config,
  },
  {
    name: "Ogier",
    domains: [
      {
        name: "ogier-og.com",
        unitSystem: "metric",
      },
      {
        name: "ogier1948.com",
        unitSystem: "metric",
      },
      {
        name: "ogierstore.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ogier.config,
  },
  {
    name: "Loulou de Saison",
    domains: [
      {
        name: "www.louloudesaison.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.louloudeSaison.config,
  },
  {
    name: "Eric Bompard",
    domains: [
      {
        name: "www.eric-bompard.com",
        unitSystem: "metric",
      },
      {
        name: "ericbompard-development.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.ericBompard.config,
  },
  {
    name: "Intersport",
    domains: [
      {
        name: "www.intersport.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.intersport.config,
  },
  {
    name: "Blackstore",
    domains: [
      {
        name: "www.blackstore.fr",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.blackstore.config,
  },
  {
    name: "Vanessa WU",
    domains: [
      {
        name: "vanessawu.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.vanessawu.config,
  },
  {
    name: "Bonpoint",
    domains: [
      {
        name: "www.bonpoint.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.bonpoint.config,
  },
  {
    name: "Paprika",
    domains: [
      {
        name: "www.paprika.fr",
        unitSystem: "metric",
        defaultBraSize: "FR",
      },
      {
        name: "www.paprika-shopping.be",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "www.paprika-shopping.de",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "www.paprika-shopping.nl",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "cassispaprika-dev.myshopify.com",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
      {
        name: "cassispaprika-prod.myshopify.com",
        unitSystem: "metric",
        defaultBraSize: "EU",
      },
    ],
    config: combinedConfig.paprika.config,
  },
  {
    name: "Fedeli Cashmere",
    domains: [
      {
        name: "www.fedelicashmere.com",
        unitSystem: "metric",
      },
      {
        name: "fedelicashmere.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.fedelicashmere.config,
  },
  {
    name: "Pyrenex",
    domains: [
      {
        name: "pyrenex.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.pyrenex.config,
  },
  {
    name: "Club Brugge",
    domains: [
      {
        name: "shop.clubbrugge.be",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.brugge.config,
  },
  {
    name: "LeCollet",
    domains: [
      {
        name: "lecollet.pl",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.lecollet.config,
  },
  {
    name: "Velour Garments",
    domains: [
      {
        name: "velourgarments.eu",
        unitSystem: "metric",
      },
      {
        name: "velour-garments.myshopify.com",
        unitSystem: "metric",
      },
    ],
    config: combinedConfig.velourGarments.config,
  },
];
